import React, { PropsWithChildren, useEffect } from "react";
import { Box } from "@material-ui/core";
import { useObserver } from "mobx-react-lite";
import { autorun } from "mobx";
import { BoxProps } from "@material-ui/core/Box/Box";
import { CoreStoreInstance } from "../../Stores/CoreStore";

export type GridProps = {
    mobileColumns?: string;
    mc?: string;
    tabletColumns?: string;
    tc?: string;
    desktopColumns?: string;
    dc?: string;
    mobileRows?: string;
    mr?: string;
    tabletRows?: string;
    tr?: string;
    desktopRows?: string;
    dr?: string;
    mobileArea?: string[];
    ma?: string[];
    tabletArea?: string[];
    ta?: string[];
    desktopArea?: string[];
    da?: string[];
    columnGap?: string | number;
    rowGap?: string | number;
    gap?: string | number;
} & PropsWithChildren<BoxProps>;

const formatAreas = (areas: string[]) => {
    if (areas && areas.length > 0) {
        return areas.map((area) => `"${area}"`).join(" ");
    }
    return "";
};

export const Grid: React.FC<GridProps> = (props: GridProps) => {
    const [columns, setColumns] = React.useState("");
    const [renderComplete, setRenderComplete] = React.useState(false);
    const [rows, setRows] = React.useState(props.desktopRows);
    const [area, setArea] = React.useState<string[]>(props.desktopArea!);
    const [view, setView] = React.useState("desktop");

    let { desktopColumns, tabletColumns, mobileColumns, desktopRows, tabletRows, mobileRows, desktopArea, tabletArea, mobileArea, columnGap, rowGap, gap, ...boxProps } = props;

    //console.log("First render of grid");

    useEffect(() => {
        //By default make tablet the same as desktop
        tabletColumns = tabletColumns === undefined ? desktopColumns : tabletColumns;
        tabletArea = tabletArea === undefined ? desktopArea : tabletArea;
        tabletRows = tabletRows === undefined ? desktopRows : tabletRows;

        desktopColumns = desktopColumns ?? props.dc;
        tabletColumns = tabletColumns ?? props.tc;
        mobileColumns = mobileColumns ?? props.mc;

        desktopRows = desktopRows ?? props.dr;
        tabletRows = tabletRows ?? props.tr;
        mobileRows = mobileRows ?? props.mr;

        desktopArea = desktopArea ?? props.da;
        tabletArea = tabletArea ?? props.ta;
        mobileArea = mobileArea ?? props.ma;

        autorun(() => {
            //console.log("autorun of grid");
            if (CoreStoreInstance.isMobile) {
                setColumns(mobileColumns!);
                setRows(mobileRows!);
                setArea(mobileArea!);
                setView("mobile");
            } else if (CoreStoreInstance.isTablet) {
                setColumns(tabletColumns!);
                setRows(tabletRows!);
                setArea(tabletArea!);
                setView("tablet");
            } else if (CoreStoreInstance.isDesktop) {
                setColumns(desktopColumns!);
                setRows(desktopRows!);
                setArea(desktopArea!);
                setView("desktop");
            } else {
                setColumns(desktopColumns!);
                setRows(desktopRows!);
                setArea(desktopArea!);
                setView("desktop");
            }
            setRenderComplete(true);
        });
    }, []);

    return useObserver(() => (
        <>
            <Box
                {...boxProps}
                display={renderComplete ? "grid" : "none"}
                gridTemplateColumns={columns ?? ""}
                gridTemplateRows={rows ?? ""}
                gridRowGap={rowGap ?? ""}
                gridColumnGap={columnGap ?? ""}
                gridGap={gap ?? undefined}
                gridTemplateAreas={formatAreas(area)}
            >
                {props.children}
            </Box>
        </>
    ));
};
Grid.defaultProps = {
    columnGap: "1em",
    rowGap: "0.5em",
    //paddingTop: "0",
    mobileColumns: "1fr",
    //tabletColumns: "1fr 1fr",
    //desktopColumns: "1fr 1fr 1fr 1fr",
    justifyContent: "normal",
    alignContent: "normal",
};
